import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RaghuserviceService } from '../raghuservice.service';

declare var $:any 


@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {

  constructor(private routes:ActivatedRoute, private service: RaghuserviceService, private http:HttpClient) { }

  // chapters:any = [
  //   {"chapt":"अध्ययाय १", "route":"1"},
  //   {"chapt":"अध्ययाय २", "route":"2"},
  //   {"chapt":"अध्ययाय ३", "route":""},
  //   {"chapt":"अध्ययाय ४", "route":""},
  //   {"chapt":"अध्ययाय ५", "route":""},
  //   {"chapt":"अध्ययाय ६", "route":""},
  //   {"chapt":"अध्ययाय ७", "route":""},
  //   {"chapt":"अध्ययाय ८", "route":""},
  //   {"chapt":"अध्ययाय ९", "route":""},
  //   {"chapt":"अध्ययाय १०", "route":""},
  //   {"chapt":"अध्ययाय ११", "route":""},
  //   {"chapt":"अध्ययाय १२", "route":""},
  //   {"chapt":"अध्ययाय १३", "route":""},
  //   {"chapt":"अध्ययाय १४", "route":""},
  //   {"chapt":"अध्ययाय १५", "route":""},
  //   {"chapt":"अध्ययाय १६", "route":""},
  //   {"chapt":"अध्ययाय १७", "route":""},
  //   {"chapt":"अध्ययाय १८", "route":""},
  //   {"chapt":"अध्ययाय १९", "route":""},
  // ]

  // data : any
  // raghuData : any = []
  sliders:any = []
  ngOnInit(): void {

    $(document).ready(function(){
      $('.carousel').carousel(
        
      );

      $('.carousel.carousel-slider').carousel({
        fullWidth: true,
        height:450,
        indicators:true,
        duration:150
      });
    });

    // this.routes.paramMap.subscribe( para => {
    //   this.data = para.get('chaptno')
      
    //   this.service.readRaghuApi().subscribe( data => {
    //     this.raghuData = data
    //   })
    // })


  // }

  this.http.get('assets/data/slider.json').subscribe( data => {
      this.sliders = data
      console.log(this.sliders)
  })

  }

}
